/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AirportsResponse } from '../../models/airports-response';
import { BaseResponse } from '../../models/base-response';

export interface CommonControllerGetAirports$Params {
}

export function commonControllerGetAirports(http: HttpClient, rootUrl: string, params?: CommonControllerGetAirports$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AirportsResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerGetAirports.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AirportsResponse;
      }>;
    })
  );
}

commonControllerGetAirports.PATH = '/common/airports';
